import React from 'react';
import {useSalesforceLeadFieldQuery} from 'api';

interface Props {
  fieldId: string;
  value: string;
  onChange: (value: string) => void;
}

const SalesforceLeadSelectOption = ({fieldId, value, onChange}: Props) => {
  const {
    data: {
      salesforceLeadField: {salesforceLeadFieldSelectOptions = []} = {},
    } = {},
  } = useSalesforceLeadFieldQuery({
    variables: {leadFieldId: fieldId},
    skip: !fieldId,
  });

  return (
    <select
      className="form-select border-c-border rounded text-base flex-1 h-[44px]"
      onChange={(e) => onChange(e.target.value)}
      value={value}>
      <option value="" />
      {salesforceLeadFieldSelectOptions.map((option) => (
        <option value={option.id} key={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SalesforceLeadSelectOption;
